import React from 'react';

const HeroSection = ({ onJoinExperience }) => {
  return (
    <div className="relative min-h-screen flex flex-col">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://customer-assets-m6fa6gv7.emergentagent.net/job_c9f8c8c9-6f95-436f-97e4-46853bac1308/artifacts/8cck9vzt_Kitesurfing-Essaouira-feature.jpg.webp"
          alt="VIVANT - Essaouira"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" />
      </div>

      {/* Nav */}
      <nav className="relative z-10 px-6 md:px-12 py-6">
        <span className="font-italiana text-xl md:text-2xl tracking-[0.4em] text-white">
          <span className="text-[#D4A574]">V</span>IVANT
        </span>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 flex-1 flex flex-col justify-center items-center text-center px-6 pb-20">
        <p className="text-[#D4A574] text-[10px] tracking-[0.5em] mb-8">SECRET CAMP • ESSAOUIRA, MAROC</p>
        
        <h1 className="font-italiana text-4xl md:text-6xl lg:text-7xl tracking-[0.08em] text-white mb-6 max-w-5xl leading-tight uppercase">
          Reviens plus fort.<br/>
          <span className="text-[#D4A574]">En 6 jours.</span>
        </h1>
        
        <p className="text-white/80 text-lg md:text-xl max-w-2xl mb-6 tracking-wide">
          Le camp qui transforme les entrepreneurs.<br className="hidden md:block" />
          Corps. Business. Réseau.
        </p>
        
        <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-8 text-white/60 text-xs md:text-sm tracking-[0.2em] uppercase">
          <span>Train</span>
          <span className="text-[#D4A574]">•</span>
          <span>Work</span>
          <span className="text-[#D4A574]">•</span>
          <span>Eat</span>
          <span className="text-[#D4A574]">•</span>
          <span>Recover</span>
          <span className="text-[#D4A574]">•</span>
          <span>Network</span>
        </div>

        <button
          onClick={onJoinExperience}
          data-testid="hero-join-btn"
          className="group bg-[#D4A574] hover:bg-[#C39563] text-white px-10 py-4 rounded-full text-sm tracking-[0.2em] font-medium transition-all hover:scale-105 uppercase"
        >
          Je veux ma place
          <svg className="inline-block ml-3 w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </button>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <svg className="w-6 h-6 text-white/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </div>
  );
};

export default HeroSection;
